import React, { Component } from "react";

import '../../style/header.css';
import HeroSection from "../Herosection/HeroSection.js";
import Category1 from "./categoria-uno.js";
import Category2 from "./categoria-due.js";
import Category3 from "./categoria-tre.js";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import ellipse from '../../images/Ellipse6.png';
import arrowUp from '../../images/ep_arrow-up-bold.png';
import Category4 from "./categoria-quattro.js";
import ProtagonistiHome from "./protagonistiHome.js";
import BoxInEvidenzaHome from "./inEvidenzaHome.js";
import AdsCarousel from "./sliderAds.js";
import DiretteHome from "./diretteHome.js";
import YoutubeClass from "../youtube/youtube.js";
import CustomHeader from "../header/header.js";


class Home extends Component{

 constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      dirette:[],
      inEvidenza:[],
      videoId:null,
      isMobile: false
    };
    this.handleScroll = this.handleScroll.bind(this);
     this.handleOpenPlayer = this.handleOpenPlayer.bind(this);
  }

  componentDidMount() {
    this.setState({ isMobile: window.innerWidth <= 768 });
    window.addEventListener('scroll', this.handleScroll);
    var apiBaseUrl2 = Constanti.url_Backend+"getVideoByCategory";
    var payload= {
      "id_categoria": 1,
      "limit":5
    }
    
      var self = this;
      axios.post(apiBaseUrl2, payload).then(function (response) {
      if (response.data.data != null){
         var location = response.data.data;
         self.setState({ inEvidenza : location })
      }else{
        console.log("non ci sono video per questo id");
      }
      self.setState({load:false});
    })
    .catch(function (error) {
    console.log(error);
    self.setState({load:false});
    });
   var apiBaseUrl = Constanti.url_Backend+"diretteYoutube";
    
      var self = this;
      axios.get(apiBaseUrl).then(function (response) {
      if (response.data.data != null){
         var dirette = response.data.data;
         self.setState({ dirette : dirette })
      }else{
        console.log("non ci sono dirette");
      }
      self.setState({load:false});
    })
    .catch(function (error) {
    console.log(error);
    self.setState({load:false});
    });
     
    
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { isVisible } = this.state;
    const scrollY = window.scrollY;

    // Mostra il pulsante se si scorre verso il basso
    if (scrollY > 100 && !isVisible) {
      this.setState({ isVisible: true });
    } 
    // Nasconde il pulsante se si torna in cima
    else if (scrollY <= 100 && isVisible) {
      this.setState({ isVisible: false });
    }
  }

  chiudiModal = (e) => {
    this.setState({ videoId: null });
  };
 

  handleInputChange = (e) => {
    this.setState({ videoUrl: e.target.value });
  };
 
  showVideo = (id) => {
    this.setState({ videoId: id });
  };

  
  chiudiModalSmall = (e) => {
    this.setState({ videoIdSmall: null });
  };
  


getYouTubeVideoId(url) {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}

  handleOpenPlayer() {
    const videoId = this.getYouTubeVideoId(this.state.dirette[0].linkDiretta);
    this.setState({ videoIdSmall: videoId });
  }

  render(){
    const { isVisible,dirette,inEvidenza,videoId,videoIdSmall,isMobile } = this.state;
    const { categorie } = this.props;
    return (
      <>
      <HeroSection diretta={dirette.length >0 ? dirette[0]:inEvidenza[0]} isDiretta={dirette.length >0 ? true:false} onShowVideo={this.showVideo} categorie={categorie}></HeroSection>
      <AdsCarousel centro="true"></AdsCarousel>
      {dirette != null && dirette.length >1 &&
      <DiretteHome name="In diretta ora" lista={dirette.slice(1)} onShowVideo={this.showVideo}/>
       }
       {categorie != null && categorie.map(el => {
    switch (el.tipo) {
        case 1:
        if (el.id === 1 && dirette.length >0){
          return <Category1 key={el.id} category={el.id} limit="5" slice="1"/>;
        }else  if (el.id === 1 && dirette.length === 0){
          return <Category1 key={el.id} category={el.id} limit="5" slice="2"/>;
        }
            return <Category1 key={el.id} category={el.id} limit="3" slice='0'/>;
        case 2:
            if (el.id === 13) {
                return (
                <>
               <ProtagonistiHome/>
                <Category2 key={el.id} category={el.id} limit="10" name={el.description} categoria ={el} />
                <BoxInEvidenzaHome video={dirette.length > 0 ? inEvidenza[0]: inEvidenza[1]}/>
                </>
               );
            }
            return <Category2 key={el.id} category={el.id} limit="10" name={el.description}/>;
        case 3:
           if (el.id === 11 || el.id === 7) {
                return <Category4 key={el.id} category={el.id} limit="10" name={el.description} categoria ={el} />;
            }
            return <Category3 key={el.id} category={el.id} limit="10" name={el.description} />;
        default:
            return null; // Puoi gestire un caso predefinito se necessario
    }
})}
 
        {isVisible &&  dirette.length > 0 && !videoIdSmall &&  (
          <div 
            style={{
              position: 'fixed',
              bottom: '0px',
              right: '10%',
              zIndex: 1000,
            }}
           onClick={this.handleOpenPlayer}
          >
            <div className="flex horizontal componentLive padding-4">
               <img src={ellipse} width={8} height={8} alt="" />
               <span className="padding-left-8 colorBlack">Live</span>
               <div className="flex horizontal justify-end width-100" ><img src={arrowUp} width={16} height={16} alt="" /></div>
            </div>
          </div>
        )}
            {videoIdSmall && (
      <div className="modal-small" id="myModal-small">
      <div className="header-modal flex horizontal justify-spacebetween">
      <div><span className="testo1">ALIS |</span> <span className="testo2">live</span></div>
      <span className="closeModal" id="closeModal" onClick={this.chiudiModalSmall}>&times;</span>
      </div>
        <div className="modal-content">
          <YoutubeClass videoId={videoIdSmall} />
        </div>
    </div>
        )}
         {videoId && (
      <div className="modal" id="myModal">
        <div className="modal-content">
          <span className="close" id="closeModal" onClick={this.chiudiModal}>&times;</span>
          <YoutubeClass videoId={videoId} />
        </div>
    </div>
        )}
     </>
      
   );
    
  }
}

export default Home; 